module.exports = __webpack_public_path__ + "img/full7-min.d8ea8b54.png";